import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from '../app.component';

// PrimeNG Components for demos
import { PrimeNGModule } from 'src/app/shared/primeng.module';

import { MarkAsteriskDirectiveModule } from '../directives/mark-asterisk.directive';
import { ContactosComponent } from './contactos.component';
import { FAZILService } from '../core/services';
import { UIService } from '../core/services/ui.service';
import { ContactosService } from './contactos.service';
import { ContactosRoutingModule } from './contactos-routing.module';
import { ContactoComponent } from './contacto.component';
import { ContactoBuscadorComponent } from './contacto-buscador.component';


@NgModule({
  declarations: [
    ContactoComponent, 
    ContactoBuscadorComponent, 
    ContactosComponent],
  bootstrap: [AppComponent],
    imports: [
        CommonModule,
        PrimeNGModule,
        MarkAsteriskDirectiveModule,
        FormsModule,
        ReactiveFormsModule,
        ContactosRoutingModule
    ],
    providers: [
        FAZILService,
        UIService,
        ContactosService,
    ],
    exports: [
        ContactoComponent,
        ContactoBuscadorComponent
      ],
})
export class ContactosModule { }
